import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import {
  spacing12,
  spacing16,
  spacing4,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import { green2, grey2, grey9 } from 'approot/shared/styles/colours.style';
import { fontSize12, fontSize14 } from 'approot/shared/styles/typography.style';

type AnswerSaveStatusOuterProps = {
  $position?: 'left' | 'right';
};
export const AnswerSaveStatusOuter = styled.div<AnswerSaveStatusOuterProps>`
  position: absolute;
  top: -${rem(spacing12)};
  ${({ $position = 'right' }) =>
    $position === 'left' ? 'left: 0;' : 'right: 0;'}
  z-index: 2;
`;

type AnswerStatusProps = {
  $isUpdating: boolean;
  $isSmall?: boolean;
};
export const AnswerSaveStatus = styled.div<AnswerStatusProps>`
  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(-360deg);
    }
  }

  ${flexCentreAlignCss}

  background-color: ${grey2};
  border-radius: ${rem(32)};
  color: ${grey9};
  display: inline-flex;
  gap: ${rem(spacing4)};

  ${({ $isSmall }) =>
    $isSmall
      ? `
        font-size: ${rem(fontSize12)};
        height: ${rem(24)};
        padding: ${rem(spacing4)} ${rem(spacing8)};
      `
      : `
        font-size: ${rem(fontSize14)};
        height: ${rem(32)};
        padding: ${rem(spacing12)} ${rem(spacing16)};
      `}

  ${({ $isUpdating }) =>
    !$isUpdating
      ? `
      background-color: ${green2};
    `
      : `
      svg {
        animation: rotation 1s linear infinite;
      }
  `}
`;
